// polyfill for Intersection Observer API
import 'intersection-observer'

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import VueResource from 'vue-resource'
Vue.use(VueResource)

import App from 'src/components/App/App.vue'
import store from './vuex/store.js'
import router from './router'
import i18n from './i18n'

import VueFactory from 'vue-factory'
Vue.use(VueFactory)

import Vuetify from 'vuetify'
Vue.use(Vuetify)

import Config from 'src/components/Services/Config/Config.js'
Vue.use(Config)

import UserConfig from 'src/components/Services/Config/UserConfig.js'
Vue.use(UserConfig)

// import VueStripeCheckout from 'vue-stripe-checkout'
// Vue.use(VueStripeCheckout)
// Vue.use(VueStripeCheckout, 'pk_test_iSqRZFAWMhUZqp2NhhLMYTP8')

import VueAnalytics from 'vue-analytics'
Config.Configs.loadConfig('site_google_analytics_id')
  .then(id => {
    if (id) {
      Vue.use(VueAnalytics, {
        id,
        checkDuplicatedScript: true,
      })
    }
  })

// import 'src/components/Auth/auth.js'

// for visuals
import VueObserveVisibility from 'src/components/AppVue/Plugins/observe-visibility'
Vue.use(VueObserveVisibility)

import 'src/components/Modal/modal'

import 'src/components/Helper/ExtensionJS.js'
import 'src/components/Helper/ExtensionJQuery.js'
import 'src/components/Helper/ExtensionBootstrap.js'

// global components
import Timeago from 'src/components/Helper/TimeAgo'
Vue.component('timeago', Timeago)

import 'src/components/Helper/PreventOverscroll.js'

//
Vue.config.productionTip = false

/* eslint-disable no-new */
const app = new Vue({
  foo : {
    bar : () => { console.log('baz') },
  },
  router,
  store,
  i18n,
  template: '<App/>',
  components: { App }
})

if (window) {
  window.VueApp = app
}

export { app, router, store }
